module.exports = __webpack_public_path__ + "assets/img/LTC039.7d378ce6.png";